import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { CATEGORY_CARDS } from "@/data/site";
import { HOME } from "@/constants/testIds";

const CategoryCards = () => {
  return (
    <section className="bg-white py-24 md:py-32">
      <div className="container-x">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
          <div>
            <p className="eyebrow mb-4">Voor wie ik fotografeer</p>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl leading-tight max-w-2xl">
              Elk verhaal <span className="italic text-gold">verdient</span> zijn eigen taal.
            </h2>
          </div>
          <p className="max-w-sm font-script text-gold text-4xl md:text-5xl leading-tight">
            Waar ben je naar op zoek?
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {CATEGORY_CARDS.map((c, i) => (
            <motion.div
              key={c.id}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, delay: i * 0.06 }}
            >
              <Link
                to={`/${c.slug}`}
                data-testid={`${HOME.categoryCard}-${c.id}`}
                className="group relative block overflow-hidden aspect-[3/4] bg-neutral-100 shadow-md hover:shadow-2xl transition-all duration-500 hover:-translate-y-1"
              >
                <img
                  src={c.image}
                  alt={c.title}
                  loading="lazy"
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/25 to-transparent" />
                <div className="absolute inset-0 p-6 md:p-8 flex flex-col justify-end">
                  <span className="font-script text-gold text-2xl md:text-3xl leading-none mb-2">
                    {c.subtitle}
                  </span>
                  <h3 className="font-serif text-white text-2xl md:text-3xl tracking-wide">
                    {c.title}
                  </h3>
                  <div className="mt-4 h-px w-8 bg-gold group-hover:w-16 transition-all duration-500" />
                  <span className="mt-3 text-[10px] uppercase tracking-[0.3em] text-white/70 group-hover:text-gold transition-colors">
                    Ontdek &amp; Boek →
                  </span>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CategoryCards;
